import * as yup from "yup";
import { stringRequired } from "../fields/index.js";

export default yup.object().shape({
  pin: stringRequired("This information is required"),
  accessCode: stringRequired("This information is required"),
});
